
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vanzari-telefonice",
      function () {
        return require("private-next-pages/vanzari-telefonice.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vanzari-telefonice"])
      });
    }
  